export function faqSearch() {

    function searchAndHighlight(searchTerm, selector) {
        if (searchTerm.length > 2) {
            var selector = selector || "#scrollbox"; //use body as selector if none provided
            var searchTermRegEx = new RegExp(searchTerm, "ig");
            var matches = $(selector).text().match(searchTermRegEx);
            if (matches != null && matches.length > 0) {
                $('.highlighted').removeClass('highlighted'); //Remove old search highlights

                //Remove the previous matches
                $('.match').removeClass('match');
                $(".accordion-item .description").show();

                if (searchTerm === "&") {
                    searchTerm = "&amp;";
                    searchTermRegEx = new RegExp(searchTerm, "ig");
                }
                $(selector).html($(selector).html().replace(searchTermRegEx, '<span class="match">' + searchTerm + '</span>'));
                
                // $('.match:first').addClass('highlighted');
                $('.match').addClass('highlighted');

                var i = 0;

                $('.next_h').off('click').on('click', function () {
                    i++;

                    if (i >= $('.match').length) i = 0;

                    $('.match').removeClass('highlighted');
                    $('.match').eq(i).addClass('highlighted');
                    $('html, body').animate({
                        scrollTop: $('.match').eq(i).offset().top - 440
                    }, 500);
                });
                $('.previous_h').off('click').on('click', function () {

                    i--;

                    if (i < 0) i = $('.match').length - 1;

                    $('.match').removeClass('highlighted');
                    $('.match').eq(i).addClass('highlighted');
                    $('html, body').animate({
                        scrollTop: $('.match').eq(i).offset().top - 440
                    }, 500);
                });
                if ($('.highlighted:first').length) { //if match found, scroll to where the first one appears

                    $(".tab_item").show();

                    $('html, body').animate({
                        scrollTop: $('.highlighted:first').offset().top - 440
                    }, 1000);
                }

                var accordion = $(".accordion");
                var accordionItem = accordion.find(".accordion-item");
                var accordionItemTitle = accordionItem.find(".title");

                accordionItemTitle.on("click", function () {

                    let $parent = $(this).closest(".accordion-item");
                    let items = $parent.siblings();
                    if (!$parent.hasClass("active")) {
                        items.removeClass("active").find(".description").slideUp();
                    }
                    $parent.toggleClass("active").find(".description").slideToggle();
                });

                return true;
            }
        }
        return false;
    }

    $(document).on('click', '.searchButtonClickText_h', function () {

        $(".highlighted").removeClass("highlighted").removeClass("match");
        if (!searchAndHighlight($('.textSearchvalue_h').val())) {
            alert("No results found");
        }
    });

    window.onscroll = function() {fixedNav()};

    var anchors = $(".faq-area");
    var space = $(".space-area");
    var sticky = anchors.offset().top;

    function fixedNav() {
        if (window.pageYOffset > sticky) {
            anchors.addClass("sticky");
            space.css("padding-top", anchors.height() + "px");
        } else {
            anchors.removeClass("sticky");
            space.css("padding-top","0");
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/faq-search.js